module.exports = __webpack_public_path__ + "static/media/cloudy-night-2.ef1c6aa1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/cloudy-night-2.svg
// module id = 514
// module chunks = 0